import { CardContentCopy } from '@modules/design-system/components/ComparativeCard/ComparativeCard.entity';

enum SubscriptionPaymentInterval {
  MONTH = 'month',
}

enum SubscriptionCurrency {
  EUR = 'EUR',
  NOK = 'NOK',
}

type SubscriptionComingSoon = {
  text: string;
};

type SubscriptionVat = {
  vatPercentage: number;
  vatTotal: number;
};

type SubscriptionPlanContentCopy = {
  [id: number]: {
    title: string;
    untranslated: string;
  };
};

interface SubscriptionContentCopy extends CardContentCopy {
  subscriptionPlans: SubscriptionPlanContentCopy;
  paymentInterval: {
    textMonth: string;
  };
  comingSoon: {
    textTitle?: string;
  };
}

interface Subscription {
  id: number | string;
  name: string;
  description?: string;
  price: number;
  vat?: SubscriptionVat;
  currency: SubscriptionCurrency;
  isPrimaryChoice?: boolean;
  paymentInterval: SubscriptionPaymentInterval;
  isShowAmount?: boolean;
  benefits?: string;
  comingSoon?: SubscriptionComingSoon[];
}

export {
  Subscription,
  SubscriptionPaymentInterval,
  SubscriptionCurrency,
  SubscriptionComingSoon,
  SubscriptionVat,
  SubscriptionContentCopy,
  SubscriptionPlanContentCopy,
};
